import { render, staticRenderFns } from "./LookVideoModal.vue?vue&type=template&id=5773bb4c&scoped=true"
import script from "./LookVideoModal.vue?vue&type=script&lang=ts"
export * from "./LookVideoModal.vue?vue&type=script&lang=ts"
import style0 from "./LookVideoModal.vue?vue&type=style&index=0&id=5773bb4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5773bb4c",
  null
  
)

export default component.exports